import React, { useState } from 'react'
import Button from '../../../../../components/Buttons/Button'
import EmptyData from '../../../../../components/EmptyData'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useQuery } from 'react-query';
import { api } from '../../../../../api/learningPath';
import { useNavigate, useParams } from 'react-router';
import Pagination from '../../../../../components/pagination/Pagination';
import Table from '../../../../../components/table/Table';
import Loader from '../../../../../components/loader/Loader';
const ActionPlanLearners = () => {

      const [perPage, setPerPage] = useState<number>(5);
      const [search, setSearch] = useState<string>("");
      const [currentPage, setCurrentPage] = useState<number>(1);
      const navigate = useNavigate()
      const orgId = JSON.parse(sessionStorage.getItem("user")!)?.org?.id;
      const {id} = useParams()
      const {activeCohortId} = useParams()
      
      const {
          data: actionPlanLearners,
          isLoading,
        } = useQuery(
          ["action plans learners", orgId, search, perPage, currentPage],
          () => {
            return api.getCohortActionPlanLearners({
              id: orgId,
              search,
              perPage,
              currentPage,
              cohortId: activeCohortId,
              actionPlanId: id
            });
          },
          {
            staleTime: 3000,  
            cacheTime: 3000,  
            select: (data) => data,
          }
        );

     let columns = React.useMemo( () => [
            {
              title: "ID",
              selector: null,
              key: "id",
              render: ({ index } : {index: number}) =>
                index +
                1 +
                ((actionPlanLearners?.meta?.page || 1) - 1) * (actionPlanLearners?.meta?.perPage || perPage ),
            },
            {
                title: "Name",
                selector: 'name',
                key: 'name',
                render: ({ item } : any) => {                      
                    return( 
                        <span>
                           {item}
                        </span>
                    )
                },
              },
              {
                title: "Email",
                selector: 'email',
                key: 'email',
                render: ({ item } : any) => {                      
                    return( 
                        <span>
                           {item}
                        </span>
                    )
                },
              },
            {
                title: "Action PlanName",
                selector: "name",
                key: "name",
                render: ({ item, row } : any) => {                      
                    return( 
                        <span className="">
                            {row?.actionPlan?.name}
                      </span>
                    )
                },
              },
            {
              title: "Goal Percentage",
              selector: 'percentageGoals',
              key: 'percentageGoals',
              render: ({ item } : any) => {                      
                  return( 
                      <span>
                         {item}%
                      </span>
                  )
              },
            },
            {
              title: "Achievement Percentage",
              selector: 'achievementPercentage',
              key: 'achievementPercentage',
              render: ({ item }: any) => {                      
                  return( 
                      <span className="pl-3">
                        {item}%
                     </span>
                  )
              },
            },
            {
                title: "Number Of Goals",
                selector: "numberOfGoals",
                key: "numberOfGoals",
                render: ({ row } : any) => {                      
                  return <span>{row?.actionPlan?.numberOfGoals}</span>
                }
              },
              {
                title: "Answered Survey",
                selector: "answeredSurvey",
                key: "answeredSurvey",
                render: ({ item } : any) => {                      
                  return  <span 
                             className={
                                 !item ? 'bi bi-x-octagon text-red-500 pl-8' :
                                'bi bi-check-circle text-green-500 pl-8'
                            }
                         />
                }
              },
            {
              title: "Action",
              selector: null,
              key: null,
              render: ({row} : any) => {           
                return  <DropdownMenu.Root>
                            <DropdownMenu.Trigger asChild>
                            <button
                                className="text-sm bi bi-three-dots-vertical font-semibold" 
                                aria-label="Customise options" 
                            />
                                </DropdownMenu.Trigger>
                                <DropdownMenu.Portal>
                            <DropdownMenu.Content className="DropdownMenuContent" sideOffset={5}>
                            <DropdownMenu.Item
                                className="DropdownMenuItem text-left  hover:bg-gray-200 text-primary-blue"
                                onClick={ () => {
                                   navigate(`/admin/cohort/survey-response/${activeCohortId}/${id}/${row?.surveyId}/${row?.responseId}`)
                                }  }
                            >
                                <i className='pr-1' /> View Survey Response
                            </DropdownMenu.Item>
                            <DropdownMenu.Separator className="DropdownMenuSeparator" />
                            </DropdownMenu.Content>
                        </DropdownMenu.Portal>
                    </DropdownMenu.Root>
              },
            },
          ],
          [1, 20, 20]
        );

    const tableProps = { isLoading, columns, data: actionPlanLearners?.data }
    const path: any = -1
  
  return (
    <div className='mt-5'>
        <header className='flex justify-between'>
            <h2>Action Plan Learners Overview</h2>
            {
             //@ts-ignore
             <Button 
                renderAs='link' 
                to={path}
                text={'Back'}
                width={'w-[130px]'}
                bgColor={'bg-customBlue'}
            />
            }
        </header> 
        <div className='bg-white pt-5 mt-3'>
            <header className='flex justify-between px-3 items-center'>
               <span className='text-sm'>Total Learners ({actionPlanLearners?.meta?.total})</span>
               <div className='w-[300px]'>
                    <input
                        type="search"
                        className="input-style bg-primaryGray"
                        placeholder="&#128269; Search Action Plan Learners...."
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setSearch(event.target.value);
                        }}
                    />
               </div>
            </header>
             {
                isLoading ? <Loader /> :
                actionPlanLearners?.meta?.total ?
                  <Table {...tableProps} />
                :
                <EmptyData text={`There is no any learners for this cohort`} />
             }
             <Pagination
              data={actionPlanLearners?.meta}
              perPage={perPage}
              pageNo={currentPage}
              setPageNo={setCurrentPage}
              setPerPage={setPerPage}
            />
        </div>
    </div>
  )
}

export default ActionPlanLearners